module.exports = __webpack_public_path__ + "img/absolut-logo.c8088e70.png";